<template>
  <div class="page_premiumBill">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="方案名称" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商" size="small">
              <el-select v-model="listQuery.name" placeholder="" size="small" clearable filterable>
                <el-option v-for="(item,index) in planList" :key="index" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保单号" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>商保管理</el-breadcrumb-item>
          <el-breadcrumb-item>保费账单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="background-color: #fff;">
        <tabs :name="name" @changeType="changeType"></tabs>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="账单汇总" name="1"></el-tab-pane>
          <el-tab-pane label="账单明细" name="2"></el-tab-pane>
        </el-tabs>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" v-if="activeName=='1'">
          <el-table-column prop="Name" label="账单月份" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Name" label="项目名称" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Name" label="在职人数" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="保费金额" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="保费月份" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="项目客服" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="备注" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="操作" align="center" fixed="right" min-width="120px" v-if="type=='underGuarantee'">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <el-button type="text" v-preventReClick @click="showDeclare = true">查看明细</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" v-if="activeName=='2'">
          <el-table-column prop="Name" label="账单月" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Name" label="项目名称" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="姓名" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="身份证号" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="险种名称" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="计费期限" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="保费金额" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="状态" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Name" label="操作" align="center" fixed="right" min-width="120px" v-if="type=='underGuarantee'">
            <template slot-scope={row}>
              <div class="eleTabBtn">
                <el-button type="text" v-preventReClick @click="showDeclare = true">查看明细</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import tabs from "./components/declareTabs.vue";
  export default {
    components: {
      tabs
    },
    data() {
      return {
        name: '/underGuarantee',
        listQuery: {
          name: ''
        },
        type:'underGuarantee',//在保/失效
        activeName:'1',
        showDropScreen: -1,
        planList: ['方案1', '方案2'], //服务商方案列表
        loading: false,
        tableData: [{
          Name: 'aaa'
        }, {
          Name: 'aaa'
        }],
        declareForm: {
          name: ''
        },
        ExcelSrc: {
          value: "",
          check: false,
          fileName: "",
        },
        serviceList: ['部门1', '部门2'],
        showDeclare: false, //增/减员弹窗
        showBatchDeclare: false, //批量增减员弹窗
      }
    },
    created() {
      if (this.$route.query.type != undefined && this.$route.query.type) {
        this.type = this.$route.query.type;
      }
    },
    methods: {
      checkPermission,
      searchHandle() {},
      handleClick() {},
      //切换增/减员状态
      changeType(val) {
        this.type = val;
      },
      //下载模板
      downImportTemp() {},
      //文件读取
      async importf() {
        const fileInput = this.$refs.upload;
        FUN.fileToBase64(fileInput.files[0]).then(res => {
          if (res) {
            console.log(res)
          } else {
            this.$message("上传Excel失败!");
            this.isUploadSuccess = false;
            this.$refs['upload'].value = null;
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<style>
  .page_premiumBill .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_premiumBill .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_premiumBill .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_premiumBill .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_premiumBill .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_premiumBill .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_premiumBill .declareForm .el-form-item__error {
    top: 34px;
  }
</style>